export var FETCH_WITHDRAW_DATA = 'FETCH_WITHDRAW_DATA';
export var SUCCESS_FETCH_WITHDRAW_DATA = 'SUCCESS_FETCH_WITHDRAW_DATA';
export var FAILURE_FETCH_WITHDRAW_DATA = 'FAILURE_FETCH_WITHDRAW_DATA';
export var CREATE_WITHDRAW = 'CREATE_WITHDRAW';
export var SUCCESS_CREATE_WITHDRAW = 'SUCCESS_CREATE_WITHDRAW';
export var FAILURE_CREATE_WITHDRAW = 'FAILURE_CREATE_WITHDRAW';
export var CANCEL_WITHDRAW = 'CANCEL_WITHDRAW';
export var SUCCESS_CANCEL_WITHDRAW = 'SUCCESS_CANCEL_WITHDRAW';
export var FAILURE_CANCEL_WITHDRAW = 'FAILURE_CANCEL_WITHDRAW';
export var FETCH_CRYPTO_DATA = 'FETCH_CRYPTO_DATA';
export var SUCCESS_FETCH_CRYPTO_DATA = 'SUCCESS_FETCH_CRYPTO_DATA';
export var FAILURE_FETCH_CRYPTO_DATA = 'FAILURE_FETCH_CRYPTO_DATA';
export var CLEAR_WITHDRAW_ERROR = 'CLEAR_WITHDRAW_ERROR';



// WEBPACK FOOTER //
// ./src/actions/withdraw/withdraw.js